var path = 'app/app.html';
var html = "<ui-view></ui-view>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/app.html
// module id = 47
// module chunks = 0